import { render, staticRenderFns } from "./GlobalSearchDialog.vue?vue&type=template&id=79fdb4d6&scoped=true&"
import script from "./GlobalSearchDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearchDialog.vue?vue&type=style&index=0&id=79fdb4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fdb4d6",
  null
  
)

export default component.exports